global.PAGE_SIZE = 20
global.BASE_URL = 'https://new-api.arabi-mobin.com/v3/site/'
// global.BASE_URL = 'http://192.168.43.92:3000/v1/site/'
// global.BASE_URL = 'http://192.168.1.5:3000/v3/site/'
global.SITE_BASE_URL = 'https://arabi-mobin.com'
